import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { forkJoin } from "rxjs";
import * as moment from "moment";
import { roleTypeOperator, roleTypeSap } from "src/_constants/roleType";

@Injectable({ providedIn: "root" })
export class EventService {
  public userInfo: any = JSON.parse(sessionStorage.getItem("currentUser"));
  public ForOP = roleTypeOperator.includes(this.userInfo.role);
  public ForSAP = roleTypeSap.includes(this.userInfo.role);
  public ForGA = ["GroupAdmin"].includes(this.userInfo.role);
  public ForRolex = this.userInfo.role === 'RolexAdmin';
  public httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.userInfo.token,
    }),
  };

  constructor(private http: HttpClient) {}

  // matched-sports

  getMatchedSports = (sportId, selectedDate) => {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/matched-sports`,
        {
          sportId: sportId,
          startDate: moment(selectedDate.startDate).valueOf(),
          endDate: moment(selectedDate.endDate).valueOf(),
        },

        this.httpOptions
      );
    }
  };

  getOurMatchedSports = (sportId, selectedDate) => {
    return forkJoin([
      this.getMatchedSports(sportId, selectedDate),
      this.getUnmatchedSports(sportId, selectedDate),
    ]);
  };

  // unmatched-sports
  getUnmatchedSports = (sportId, selectedDate) => {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/unmatched-sports`,
        {
          sportId: sportId,
          startDate: moment(selectedDate.startDate).valueOf(),
          endDate: moment(selectedDate.endDate).valueOf(),
        },

        this.httpOptions
      );
    }
  };

  // All-sports
  getOurSports = (sportId, selectedDate) => {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/get-sport-radar-cards`,
        {
          sportId: sportId,
          startDate: moment(selectedDate.startDate).valueOf(),
          endDate: moment(selectedDate.endDate).valueOf(),
        },

        this.httpOptions
      );
    }
  };

  // update-sport-card
  updateSportCard = (data) => {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/update-sport-card`,
        data,
        this.httpOptions
      );
    }
  };

  unBlockMarket(
    operatorId: string,
    eventId: string,
    marketId: string,
    providerId: string,
    sportId: string
  ) {
    if (this.ForSAP || this.ForRolex) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/unblock-market`,
        {
          eventId: eventId,
          marketId: marketId,
          providerId: providerId,
          sportId: sportId,
        },
        this.httpOptions
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/opadmin/unblock-market`,
        {
          operatorId: operatorId,
          eventId: eventId,
          marketId: marketId,
          providerId: providerId,
          sportId: sportId,
        },
        this.httpOptions
      );
    }
  }
  blockMarket(
    operatorId: string,
    eventId: string,
    marketId: string,
    providerId: string,
    sportId: string
  ) {
    if (this.ForSAP || this.ForRolex) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/block-market`,
        {
          eventId: eventId,
          marketId: marketId,
          providerId: providerId,
          sportId: sportId,
        },
        this.httpOptions
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/opadmin/block-market`,
        {
          eventId: eventId,
          marketId: marketId,
          providerId: providerId,
          sportId: sportId,
          operatorId: operatorId,
        },
        this.httpOptions
      );
    }
  }
  suspendMarket(
    eventId: string,
    marketId: string,
    providerId: string,
    sportId: string
  ) {
    if (this.ForSAP || this.ForRolex) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/suspend-market`,
        {
          eventId: eventId,
          marketId: marketId,
          providerId: providerId,
          sportId: sportId,
        },
        this.httpOptions
      );
    }
  }
  resumeMarket(
    eventId: string,
    marketId: string,
    providerId: string,
    sportId: string
  ) {
    if (this.ForSAP || this.ForRolex) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/resume-market`,
        {
          eventId: eventId,
          marketId: marketId,
          providerId: providerId,
          sportId: sportId,
        },
        this.httpOptions
      );
    }
  }
  getModalMarketData(
    eventId: string,
    marketId: string,
    providerId: string,
    sportId: string
  ) {
    return this.http.post<any>(
      `${environment.apiUrl}/sapadmin/get-op-markets`,
      {
        eventId: eventId,
        marketId: marketId,
        providerId: providerId,
        sportId: sportId,
      },
      this.httpOptions
    );
  }
  unBlocKOpkMarket(
    payload: any
  ) {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/unblock-op-market`,
        payload,
        this.httpOptions
      );
    }
  }

  blockOpMarket(payload:any) {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/block-op-market`,
        payload,
        this.httpOptions
      );
    }
  }

  eventOpenBets(providerId: string, sportId: string, eventId: string) {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/get-open-bets`,
        {
          eventId: eventId,
          providerId: providerId,
          sportId: sportId,
        },
        this.httpOptions
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/opadmin/get-open-bets`,
        {
          eventId: eventId,
          providerId: providerId,
          sportId: sportId,
          operatorId: this.userInfo.operatorId,
        },
        this.httpOptions
      );
    }
  }

  getMarketRisk(
    providerId: string,
    sportId: string,
    eventId: string,
    marketId: string
  ) {
    return this.http.post<any>(
      `${environment.apiUrl1}/reports/get-user-book-report`,
      {
        providerId: providerId,
        sportId: sportId,
        eventId: eventId,
        marketId: marketId,
      },
      this.httpOptions
    );
  }
}
